import { render, staticRenderFns } from "./ExcelDownload.vue?vue&type=template&id=27e4a4e6&scoped=true&"
import script from "./ExcelDownload.vue?vue&type=script&lang=js&"
export * from "./ExcelDownload.vue?vue&type=script&lang=js&"
import style0 from "./ExcelDownload.vue?vue&type=style&index=0&id=27e4a4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e4a4e6",
  null
  
)

export default component.exports